const { React } = window;

class TheShowroom {
  constructor(props) {
    Object.assign(this, props);

    this.isAdmin = props.shopifyId === customer.id;
  }
}

const showroomReducer = (state = {}, action) => {
  switch (action.type) {
    case "setShowroom":
      return new TheShowroom({ ...action.showroom });
    default:
      return state;
  }
};
